import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';

const MIGRATED_VERSION:DesignerVersion = 49;

export const migration_48_49:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        if( designState.surface && designState.surface.pages )
        {
            Object.values(designState.surface.pages).forEach((page:any) =>
            {
                if( page.artboard && page.artboard.allBoxes )
                {
                    const removeBoxIds = Object.values(page.artboard.allBoxes)
                        .filter((box:any) => box.component.name === 'FilePicker')
                        .map((box:any) => box.id);

                    const removeBindings = Object.values(designState.bindings)
                        .filter((binding:any) => removeBoxIds.indexOf(binding.boxId) >= 0);

                    const removeBindingIds = removeBindings.map((binding:any) => binding.id);
                    const removeRangeIds = removeBindings.map((binding:any) => binding.rangeId);

                    removeBoxIds.forEach(removeBoxId =>
                        delete page.artboard.allBoxes[removeBoxId]
                    );

                    Object.values(page.artboard.allBoxes).forEach((boxSnapshot:any) =>
                    {
                        boxSnapshot.children = boxSnapshot.children.filter(childId =>
                            removeBoxIds.indexOf(childId) < 0
                        );
                    });

                    removeBindingIds.forEach(removeBindingId =>
                        delete designState.bindings[removeBindingId]
                    );

                    const workbook:any = Object.values(designState.spreadsheets.workbooks)[0];
                    const namedRanges = workbook && workbook.runtime && workbook.runtime.namedRanges;
                    if( namedRanges )
                    {
                        removeRangeIds.forEach(removeRangeId =>
                            delete namedRanges[removeRangeId]
                        );
                    }
                }
            });
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};
